<template>
  <modal v-if="modalShow" @close="modalShow = false">
    <template slot="header">
      <h4 class="modal-title">{{ title }}</h4>
      <md-button
        class="md-simple md-just-icon md-round modal-default-button"
        @click="modalShow = false"
      >
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <p v-html="par" class="modal-text" v-for="par in text" :key="par" />
    </template>
    <template slot="footer">
      <md-button class="md-success md-simple" @click="modalShow = false"
        >Ok</md-button
      >
    </template>
  </modal>
</template>

<script>
import Modal from './Modal'
export default {
  name: 'ConfiguratorModal',
  components: { Modal },
  data() {
    return {
      modalShow: false,
      title: '',
    }
  },
  mounted() {},
  methods: {
    open(data) {
      this.text = data.text
      this.title = data.title
      this.modalShow = true
    },
  },
}
</script>

<style lang="scss">
.modal-text {
  text-align: justify;
  white-space: pre-line;
  @media screen and (max-width: 576px) {
    font-size: 13px;
    line-height: 1.3em;
  }
}
</style>
